import { adfModelTypeMap, fileTypeLinkedServiceTypes } from 'app/registries/consts/adf-model-type-map-const';
import { IDatasetTypeMetadata } from 'app/extensibility/metadatas/resource-type/dataset-type-metadata';

import { delimitedTextCompressionTypeOptions, delimitedTextEncodingNameOptions } from '../consts/v2Dataset-const';
import { compressionCodecType } from 'shell-models-lib';
import {
    preserveZipFileAsFolderMetadata,
    preserveCompressionFileAsFolderMetadata,
    maxRowsPerFileAndPrefixMetadata,
    quoteAllTextMetadata,
    fileExtensionMetadata
} from '../consts/metadata-consts';
import { ColumnType, defaultSupportedColumnTypes } from 'app/shared/utils/column-type.util';

// snappy only should exist for parquet/orc. keeping it in adf for backward compatibility
export const compressionCodecOptions = delimitedTextCompressionTypeOptions.concat(
    __IS_FABRIC_DPE__
        ? []
        : [
            {
                label: compressionCodecType.snappy,
                value: compressionCodecType.snappy
            },
            {
                label: compressionCodecType.lz4,
                value: compressionCodecType.lz4
            }
        ]);

export const delimitedTextMetadata: IDatasetTypeMetadata = {
    type: adfModelTypeMap.delimitedText.datasetType,
    displayName: stringResources.ModelName_DelimitedTextDataset,
    supportLinkedServiceTypes: fileTypeLinkedServiceTypes,
    supportDeleteActivity: true,
    isSource: true,
    isSink: true,
    datasetKind: 'file',
    icon: {
        className: 'svg-i-20x20-csv'
    },
    isFirstClass: true,
    category: ['File'],
    isV2FormatDataset: true,
    supportDataFlowSource: true,
    supportDataFlowSink: true,
    supportGetMetadataActivity: true,
    formatReadSettingControls: [
        {
            type: 'parameterizable',
            child: {
                type: 'textbox-number',
                bind: 'skipLineCount',
                label: stringResources.SkipLineCountLabel,
                min: 0
            },
            dynamicContentTextClass: 'input-spaced'
        }
    ],
    compressionReadSettingControls: {
        [compressionCodecType.ZipDeflate]: [preserveZipFileAsFolderMetadata],
        [compressionCodecType.TarGZip]: [preserveCompressionFileAsFolderMetadata],
        [compressionCodecType.tar]: [preserveCompressionFileAsFolderMetadata]
    },
    formatWriteSettingControls: (__IS_FABRIC_DPE__ ? [] : [quoteAllTextMetadata]).concat([
        fileExtensionMetadata,
        maxRowsPerFileAndPrefixMetadata
    ]),
    compressionOptions: compressionCodecOptions,
    encodingOptions: delimitedTextEncodingNameOptions,
    supportDataTypes: defaultSupportedColumnTypes.concat(ColumnType.Date),
    fileExtensions: ['*.csv', '*.tsv', '*.txt', '*']
};
